/** BroadcastChannel name — other tabs reload when maintenance is toggled. */
export const MAINTENANCE_MODE_BROADCAST_CHANNEL = 'bhg-maintenance-mode';
